export default "__VITE_ASSET__CVg2I6MU__ 1200w";